import { useEffect, useRef, useState, type RefObject } from "react"

export function useContainerWidth<T extends HTMLElement = HTMLDivElement>(
  initial = 0,
): [RefObject<T>, number] {
  const ref = useRef<T | null>(null)
  const [width, setWidth] = useState(initial)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    // Initial measure
    setWidth(el.clientWidth)

    let cleanup = () => {}

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver((entries) => {
        for (const entry of entries) {
          // Prefer contentBoxSize when available, fallback to contentRect
          const w =
            Array.isArray(entry.contentBoxSize) && entry.contentBoxSize[0]
              ? entry.contentBoxSize[0].inlineSize
              : entry.contentRect?.width || el.clientWidth
          setWidth(w)
        }
      })
      ro.observe(el)
      cleanup = () => ro.disconnect()
    } else {
      // Fallback: window resize
      const onResize = () => setWidth(el.clientWidth)
      window.addEventListener("resize", onResize)
      cleanup = () => window.removeEventListener("resize", onResize)
    }

    return cleanup
  }, [])

  return [ref as RefObject<T>, width]
}
